import { MediaFile } from "src/types/media";


export const parseMediaMetadata = async (file: File): Promise<MediaFile | null> => {
  if(!file) {
    return null;
  }
  let mediaType = "image";
  if (file.type.match('image.*')) {
    mediaType = "image";
  } else if (file.type.match('video.*')) {
    mediaType = "video";
  }

  if(mediaType === "image") {
    return parseImageMetadata(file);
  } else if(mediaType === "video") {
    return parseVideoMetadata(file);
  }

  return null;
}

export const parseImageMetadata = async (file: File) : Promise<MediaFile | null> => {
  const fileAsDataURL = window.URL.createObjectURL(file)
  return new Promise<HTMLImageElement>((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = reject;
    image.src = fileAsDataURL;
  }).then((image: HTMLImageElement) => {
    return {
      id: file.name,
      entityType: "media-preview",
      type: "image",
      full: fileAsDataURL,
      thumbnail: fileAsDataURL,
      width: image.width,
      height: image.height,
    } as MediaFile
  }).catch((error) => {
    console.error(error)
    return null;
  });
}

export const parseVideoMetadata = async (file: File) : Promise<MediaFile | null> => {
  const fileAsDataURL = window.URL.createObjectURL(file);
  return new Promise<HTMLVideoElement>((resolve, reject) => {
    const video = document.createElement('video');

    video.addEventListener("loadedmetadata", function () {
        resolve(video);
    }, false);

    video.onerror = reject;

    video.src = fileAsDataURL;
  }).then((video: HTMLVideoElement) => {
    return {
      id: file.name,
      entityType: "media-preview",
      type: "video",
      full: fileAsDataURL,
      thumbnail: fileAsDataURL,
      width: video.videoWidth,
      height: video.videoHeight,
    } as MediaFile
  }).catch((error) => {
    console.error(error)
    return null;
  });
}